import DataQuery from "data/DataQuery";
import IFileService from "data/IFileService";
import { Billings_DownloadDocument } from "data/endpoints";
import { useSearchParams } from "features/shared/hooks/useSearchParams";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { InvoiceDetailRouteProps } from "features/invoices/pages/InvoiceDetail";

export const useAutoSpotTableDownload = () => {
  const fileService = useInjection<IFileService>(IocTypes.FileService);
  const { invoiceId } = useParams<InvoiceDetailRouteProps>();
  const queryParams = useSearchParams();
  const history = useHistory();

  useEffect(() => {
    if (hasDownloadFileParams()) {
      let query = getDownloadQuery();
      fileService.downloadFile(query);
      history.replace(history.location.pathname);
    }
  }, []);

  const hasDownloadFileParams = (): boolean => {
    let downloadParam = queryParams.get("downloadFile");
    let billingIdParam = queryParams.get("billingId");
    let downloadTypeParam = queryParams.get("downloadType");

    return (
      downloadParam != null &&
      downloadParam === "true" &&
      billingIdParam != null &&
      downloadTypeParam != null
    );
  };

  const getDownloadQuery = (): DataQuery => {
    let routeParams = new URLSearchParams(queryParams);
    routeParams.delete("downloadFile");

    let query: DataQuery = {
      url: Billings_DownloadDocument,
      params: new URLSearchParams([["InvoiceId", invoiceId]]),
      routeParams: routeParams
    };

    return query;
  };
};
